export enum OrderSMSEvent {
  catch_all = 'catch_all',
  loaded = 'loaded',
  pickup_expiring = 'pickup_expiring',
  pickup_expired = 'pickup_expired',
  transferred_to_counter = 'transferred_to_counter',
}

export interface IOrderSMSTemplate {
  id?: number;
  content: string;
  event_type: string;
  organization_id: string;
  attach_pickup_qr?: boolean;
  cabinet_id?: string;
  activated_at?: Date;
}

export class OrderSMSTemplate implements IOrderSMSTemplate {
  public id?: number;
  public content: string;
  public attach_pickup_qr: boolean;
  public cabinet_id?: string;
  public organization_id: string;
  public event_type: string;
  public activated: boolean;
  public activated_at?: Date;

  constructor(args: IOrderSMSTemplate) {
    this.id = args.id;
    this.content = args.content;
    this.attach_pickup_qr = args.attach_pickup_qr !== false;
    this.cabinet_id = args.cabinet_id;
    this.organization_id = args.organization_id;
    this.event_type = args.event_type;
    this.activated_at = args.activated_at;
    this.activated = args.activated_at !== undefined && args.activated_at !== null;
  }
}

export function allSmsTemplates(): Array<OrderSMSTemplate> {
  const result = [];
  for (const eventType of [
    OrderSMSEvent.catch_all,
    OrderSMSEvent.loaded,
    OrderSMSEvent.pickup_expired,
    OrderSMSEvent.pickup_expiring,
    OrderSMSEvent.transferred_to_counter
  ]) {
    const templateInterface: IOrderSMSTemplate = {
      content: 'CHANGE ME',
      event_type: eventType,
      organization_id: ''
    };
    
    const newTemplate = new OrderSMSTemplate(templateInterface);
    result.push(newTemplate);
  }

  return result;
}
